
export const CANDIDATE_STATUS = Object.freeze({
    APPLIED: 12,
    INTERVIEW: 13,
    OFFER: 14,
    HIRED: 15,
    REJECTED: 16,
    KIV: 17,
    RESIGNED: 18,
    TERMINATED: 19,
});

export const CANDIDATE_STATUS_OPTIONS = Object.freeze([
    {
        value: 12,
        text: 'Applied',
        update: [ 13 ],
    },
    {
        value: 13,
        text: 'Interview',
        update: [ 14, 16, 17 ],
    },
    {
        value: 14,
        text: 'Offer',
        update: [ 15, 16 ],
    },
    {
        value: 15,
        text: 'Hired',
        update: [ 18, 19 ],
    },
    {
        value: 16,
        text: 'Rejected',
        update: [  ],
    },
    {
        value: 17,
        text: 'KIV',
        update: [ 14, 16 ],
    },
    {
        value: 18,
        text: 'Resigned',
        update: [  ],
    },
    {
        value: 19,
        text: 'Terminated',
        update: [  ],
    },
]);